<template>
<div class="questionList1">
    <div  class="box" v-for="(item,index) in dataList" :key="'dataList'+index">
        <div class="box_flex" v-show="!item.editShow">
            <div class="left-box">
                <div class="subjectBox">
                    <div class="subjectTitle">
                        <span>{{index + 1}}.</span>
                        <span>（{{item.questiontypename}}，分值{{item.defaultscore}}）</span>
                        <!--<span v-html="item.subject"></span>-->
                    </div>
                    <div v-html="item.subject"></div>
                    <div class="subjectMain" v-if="item.questiontype != 7">
                        <span class="lable">答案：</span>
                        <div class="answerBox">
                            <!--选择题-->
                            <div class="selectSub" v-for="(item2,idx) in item.optionslist" :key="'selectSub'+idx" v-if="item.questiontype=='1'||item.questiontype=='2'||item.questiontype=='3'">
                                <span class="serial">{{item2.optionsvalue}}、</span>
                                <span v-html="item2.optionsinfo"></span>
                                <span class="anster-tip"><span v-show="item2.isrightanswer=='1'" >（正确答案）</span></span>
                            </div>
                            <!--判断题-->
                            <div class="selectSub" v-if="item.questiontype=='4'">{{item.finalanswer==='T'?'正确':'错误'}}</div>
                            <!--问答题-->
                            <div class="selectSub" v-if="item.questiontype=='6'" v-html="item.referenceanswer"></div>
                        </div>
                        <div class="answerOtherBox" v-if="item.questiontype=='5'">
                            <!--填空题-->
                            <div class="otherSub" v-for="(item3,index) in item.finalanswerblank.answerblank" :key="index">
                                <span>{{item3}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="btn innerbox">
                    <el-button @click="handleEdit(item,index)" type="text" size="small">编辑</el-button>
                    <span class="separator">|</span>
                    <el-button @click="handleDel(index)" type="text" size="small">删除</el-button>
                </div>
                <div class="setting-item innerbox flexstart" v-if="item.questiontype != 7">
                    <div>每题<el-input @input="changeInput(item.questiontype)" v-model="item.defaultscore" placeholder=""></el-input>分</div>
                </div>
                <div class="moveBtn">
                    <el-button v-show="index>0" @click="topMove(index,'up')" type="text" size="small"><i class="el-icon-arrow-up"></i>上移</el-button>
                    <el-button v-show="index<dataList.length-1" @click="topMove(index,'down')" type="text" size="small"><i class="el-icon-arrow-down"></i>下移</el-button>
                </div>
            </div>
        </div>
        <div class="innerbox" v-if="item.questiontype == 7" v-show="!item.editShow">
            <div class="box_flex" v-for="(obj,index2) in item.questioninfo" :key="'questioninfo'+index2">
                <div class="left-box">
                    <div class="subjectBox">
                        <div class="subjectTitle">
                            <span>{{index + 1}}.{{index2 + 1}}</span>
                            <span>（{{obj.questiontype | typeName}}，分值{{obj.defaultscore}}）</span>
                            <!--<span v-html="obj.subject"></span>-->
                        </div>
                        <span v-html="obj.subject"></span>
                        <div class="subjectMain">
                            <span class="lable">答案：</span>
                            <div class="answerBox">
                                <!--选择题-->
                                <div v-if="['1','2','3'].indexOf(obj.questiontype) > -1">
                                    <div class="selectSub"  v-for="(obj2,idx) in obj.optionslist" :key="'optionslist'+idx">
                                        <span class="serial">{{letter[idx]}}、</span>
                                        <span v-html="obj2.optionsinfo"></span>
                                        <span class="anster-tip"><span v-show="obj2.isrightanswer=='1'">（正确答案）</span></span>
                                    </div>
                                </div>
                                <!--判断题-->
                                <div class="selectSub" v-if="obj.questiontype=='4'">{{obj.finalanswer==='T'?'正确':'错误'}}</div>
                                <!--问答题-->
                                <div class="selectSub" v-if="obj.questiontype=='6'" v-html="obj.referenceanswer"></div>
                                <!--填空题-->
                                <div class="answerOtherBox" v-if="obj.questiontype=='5'">{{obj.finalanswerblank.answerblank.join(',')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="setting-item innerbox flexstart">
                        <div>每题<el-input @input="_setScore(item)" v-model="obj.defaultscore" placeholder=""></el-input>分</div>
                    </div>
                </div>
            </div>
        </div>
        <!--编辑-->
        <div class="box" v-if="item.editShow">
            <!--<p>第{{index+1}}题</p>-->
            <subEdit v-if="item.editShow" :itemData="item" :itemIndex="index"></subEdit>
        </div>
    </div>
</div>
</template>

<script>
import {getExampaperQuesList} from 'api/testPaperApi'
import {mapGetters, mapActions} from 'vuex'
import SubEdit from 'views/operateTool/testpaper/components/subEdit.vue'
import {_filter, question, letter} from 'api/enumCode'
export default {
    name: 'questionList1',
    props:['dataList'],
    data() {
        return {
            setting: {
                defaut: ''
            },
            letter: letter
            //dataList:[],
        }
    },
    created(){
    },
    mounted() {
        //this._getList()
    },
    methods: {
        _setScore(item) {
            let num = 0
            item.questioninfo.forEach(obj => {
                num += obj.defaultscore * 1
            })
            item.defaultscore = num
            this.$bus.emit('showSettingNum',7)
        },
        changeInput(ind){
            this.$bus.emit('showSettingNum',ind)
        },
        _getList(){
            this.setLoading(true);
            let params = {
                innerid:this.$route.query.id
            };
            getExampaperQuesList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false);
                    this.dataList=data.data.content;
                },
                error: data => {
                    this.setLoading(false);
                    this.$message.error(data.msg)
                }
            })
        },
        // 跳转至编辑
        handleEdit(item,index){
            this.dataList.forEach((item,ind)=>{
                if(index == ind){
                    this.$set(item,'editShow',!item.editShow);
                    this.$bus.emit('showSetting',item.questiontype)
                }else{
                    this.$set(item,'editShow',false)
                }
            })
            // this.$router.push({name: 'TestSubEdit', query: {}})
        },
        // 上移
        topMove(index,type) {
            this.$bus.emit('changeMove',{index:index,move:type})
        },

        handleDel(index) {
            this.$bus.emit('topicDel',{index:index})
        },
        ...mapActions([
            'setLoading',
        ])
    },
    filters: {
        typeName: function (value) {
            return _filter(value, question.type)
        }
    },
    watch: {
        itemData: {
            handler: function() {
                if (this.itemData.questiontype == 7) {
                    this.$nextTick(() => {
                        this.$refs.material._setQuestionList()
                    })
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([

        ])
    },
    components: {SubEdit}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.questionList1 {
    line-height: 25px;
    .box{
        padding: 20px;
        box-sizing: border-box;
        background:  #F5F7FA;
        .box_flex{
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        .innerbox{
            padding: 20px 0 0 20px;
            box-sizing: border-box;
            .left-box{
                padding-bottom: 20px;
            }
        }
        .left-box{
            /*flex-grow: 1;*/
            width: 520px;
            .subjectBox{
                .subjectTitle{
                }
                .subjectMain{
                    display: flex;
                    margin-top: 30px;
                    .lable{
                        width: 42px;
                        min-width: 42px;
                        white-space: nowrap;
                    }
                    .anster-tip{
                        width: 84px;
                        min-width: 84px;
                        margin-left: 15px;
                        white-space: nowrap;
                        color: #909399;
                    }
                    .answerBox{
                        display: flex;
                        flex-direction: column;
                        .selectSub{
                            display: flex;
                            margin-bottom: 20px;
                            align-items: center;
                            .serial{
                                align-self: flex-start;
                            }
                        }
                        .selectSub:last-child{
                            margin-bottom: 0;
                        }
                        .otherSub{
                            display: flex;
                            flex-direction: row;
                        }
                    }
                    .answerOtherBox{
                        display: flex;
                        flex-direction: row;
                        .otherSub{
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
        .right-box{
            width: 200px;
            /*height: 100px;*/
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            flex-direction: column;
            .moveBtn{
                margin-top: 30px;
                .el-button{
                    color: #999;
                    min-width: 60px;
                    .el-icon-arrow-down,.el-icon-arrow-up{
                        width: 15px;
                        height: 15px;
                        line-height: 15px;
                        border-radius: 50%;
                        border: 1px solid rgba(144,147,153,1);
                        margin-right: 3px;
                    }
                }
            }
            .innerbox+.innerbox{
                margin-top: 30px;
            }
            .btn{
                color:  #409EFF ;
                .el-button{
                    min-width: 48px !important;
                    height: 32px;
                }
            }
            .setting-item{
                .el-input{
                    width: 100px;
                    height: 32px;
                    margin: 0 10px;
                }
            }
        }
    }
    .box+.box{
        margin-top: 20px;
    }
}
</style>
